import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { useTopicContext } from '../../contexts/topic/TopicContext';
import DefaultRecord from '../../images/DefaultRecord.svg';
import { faArrowLeft, faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Card from '../card/card';
import PaginatedSearchableList from '../searchable-list/paginatedSearchableList';
import { Topic } from './Topic';
import './topic-list.css';

interface Props {
    topics?: Topic[]
}

const TopicList: FC<Props> = () => {
    const history = useHistory();
    const topicContext = useTopicContext();

    function InitialsBadge(item: any) {
        return <svg className={`bg-no-repeat ${item.isDefault ? '' : 'pt-1'}`} height={25} width={25} >
                <circle fill="#908E8E" cx="10" cy="10" r="10"></circle>
                <text
                    fill="#ffffff"
                    fontSize="13"
                    textAnchor="middle"
                    x="10"
                    y="14">
                    {item.label[0]}
                </text>

                {item.isDefault ?
                    <>
                        <image
                            width={13}
                            fill="#4CBB17"
                            y={12}
                            x={12}
                            href={DefaultRecord} />
                    </>
                    : null}
            </svg>
    }

    //Showing selected item if it's not in the current data set
    const selectedItem = topicContext.selectedItem;
    if (selectedItem) {
        const itemFound = topicContext.data.find(option => (+option.value === +selectedItem.value))
 
        if(!!!itemFound) {
            topicContext.data.unshift(selectedItem)
        }
    }

    const navigateToMainView = (event) => {
        history.push(topicContext.topic.allItemsPath);
    };

    const navigateToItem = (itemIndex) => {
        history.push(topicContext.topic.itemPath + topicContext.data[itemIndex].value);
    };

    const findSelectedItems = () => {
        return topicContext.data.find(item => +item.value === +topicContext.itemId)
                ? [topicContext.data.findIndex(item => +item.value === +topicContext.itemId)]
                : []
    };
    
    return <Card hasBorder={false} className="bg-white ml-4 p-4 content-selection-list overflow-y-auto">
        <div className="flex flex-row justify-between pb-4">
            <label className='border text-gray-700 bg-white text-xs p-1 rounded-md flex flex-grow mr-4 my-auto'>
                {topicContext.topic.title}
            </label>
            <button id="fullScreenBtn" type="button" className="ml-2 bg-portal-blue-primary-shade2 text-white rounded-lg shadow-lg" onClick={(e) => navigateToMainView(e)}>
                <FontAwesomeIcon icon={faArrowLeft} className="mx-2 w-8"></FontAwesomeIcon>
            </button>
        </div>

        <PaginatedSearchableList
            items={topicContext.data.map((item, index) => (
                <div className="flex flex-row items-center cursor-pointer">
                    {InitialsBadge(item)}
                    <div className="companyName pl-2 topic-item">{item.label}</div>
                </div>
            ))}
            onSelect={navigateToItem}
            title="Names"
            selectedItems={findSelectedItems()}
            searchBoxClassName="mb-4"
            titleClassName="mb-0"
            stripedListClassName="mb-2"
            stripedListItemClassName="p-1 pl-3"
            selectedListItemClassName="p-1 pl-1-5 border-l-7 border-portal-blue-primary bg-selection-highlight border-t-selection-highlight border-r-selection-highlight border-b-selection-highlight"
            pageSizeSet={[]}
            onSearch={topicContext.onSearch}>
        </PaginatedSearchableList>
    </Card>;
};

export default TopicList;
